/**
 * KAN-1003: согласие при регистрации: регистрация = акцепт соглашения и
 * согласие с политикой конфиденциальности.
 */
import { Link } from 'react-router-dom';
import { LEGAL_PATHS } from '@/content/legal/support';

const LINK_CLASS = 'font-medium text-blue-600 hover:text-blue-500 hover:underline';

export function RegisterConsent() {
  return (
    <p data-testid="register-consent" className="text-xs leading-relaxed text-gray-500">
      Регистрируясь, вы принимаете{' '}
      <Link to={LEGAL_PATHS.terms} className={LINK_CLASS}>
        Пользовательское соглашение
      </Link>{' '}
      и{' '}
      <Link to={LEGAL_PATHS.privacy} className={LINK_CLASS}>
        Политику конфиденциальности
      </Link>
      .
    </p>
  );
}
